import type {
  NotificationSubscriptionServerType,
  NotificationSubscriptionType,
} from '@/lib/types/notificationSubscription.types'

export const normalizeNotificationSubscription = (
  data: NotificationSubscriptionServerType,
): NotificationSubscriptionType => {
  return {
    subscriber: data.subscriber,
    topic: data.topic,
    enabled: data.enabled,
    channels: {
      inApp: data.channels.in_app,
      email: data.channels.email,
    },
  }
}
